var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "app-sidenav",
      attrs: {
        persistent: "",
        "mini-variant": _vm.$store.state.layout.miniVariant,
        clipped: _vm.clipped,
        "enable-resize-watcher": "",
        fixed: "",
        app: "",
        width: "350",
        "mini-variant-width": "68"
      },
      model: {
        value: _vm.$store.state.layout.drawer,
        callback: function($$v) {
          _vm.$set(_vm.$store.state.layout, "drawer", $$v)
        },
        expression: "$store.state.layout.drawer"
      }
    },
    [
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href:
            "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
        }
      }),
      _vm._v(" "),
      _c("v-tooltip", { attrs: { bottom: "" } }, [
        _c(
          "div",
          {
            staticClass: "app-logo",
            attrs: { slot: "activator" },
            on: {
              click: function($event) {
                return _vm.sendInicio()
              }
            },
            slot: "activator"
          },
          [
            _c(
              "h1",
              { staticClass: "app-title" },
              [
                _c("v-icon", [_vm._v("dashboard")]),
                _c("span", [_vm._v(_vm._s(_vm.$t("app.title")))])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("Inicio")])
      ]),
      _vm._v(" "),
      _c(
        "v-list",
        { attrs: { id: "sidenav-menu" } },
        _vm._l(_vm.menu, function(item) {
          return item.children.length > 0
            ? _c(
                "v-list-group",
                {
                  key: item.id,
                  staticClass: "sidenav-parent",
                  attrs: { "prepend-icon": item.icono, "no-action": "" },
                  model: {
                    value: item.active,
                    callback: function($$v) {
                      _vm.$set(item, "active", $$v)
                    },
                    expression: "item.active"
                  }
                },
                [
                  _c(
                    "v-list-tile",
                    {
                      attrs: { slot: "activator", "data-url": item.url },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toggleGroup(item)
                        }
                      },
                      slot: "activator"
                    },
                    [
                      _c(
                        "v-list-tile-content",
                        [
                          _c(
                            "v-list-tile-title",
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.getLabel(item)))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(item.children, function(subItem) {
                    return _c(
                      "v-list-tile",
                      {
                        key: subItem.id,
                        staticClass: "sidenav-children",
                        attrs: { "data-url": subItem.ruta },
                        on: {
                          click: function($event) {
                            return _vm.send(subItem.ruta)
                          }
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "material-symbols-outlined span-icon"
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(subItem.icono) +
                                "\n        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-tile-content",
                          { staticClass: "pl-2" },
                          [
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "", "close-delay": "0" } },
                              [
                                _c(
                                  "v-list-tile-title",
                                  {
                                    attrs: { slot: "activator" },
                                    slot: "activator"
                                  },
                                  [_vm._v(_vm._s(_vm.getLabel(subItem)))]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.getLabel(subItem)))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _c(
                "v-list-tile",
                {
                  staticClass: "sidenav-one",
                  attrs: { "data-url": item.ruta },
                  on: {
                    click: function($event) {
                      return _vm.send(item.ruta)
                    }
                  }
                },
                [
                  _c("v-list-tile-action", [
                    _c(
                      "span",
                      { staticClass: "material-symbols-outlined span-icon" },
                      [
                        _vm._v(
                          "\n          " + _vm._s(item.icono) + "\n        "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c(
                        "v-list-tile-title",
                        { class: item.ruta ? "" : "font-weight-bold" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.getLabel(item)) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-435ba636", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-435ba636","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/layout/AppSidenav.vue
// module id = null
// module chunks = 